"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var braintree_web_1 = __importDefault(require("braintree-web"));
var react_1 = __importStar(require("react"));
exports.default = (function (_a) {
    var items = _a.items;
    var paypalButtonContainerId = 'paypal-express-cart-container';
    var _b = __read((0, react_1.useState)(), 2), paypalCheckout = _b[0], setPaypalCheckout = _b[1];
    var _c = __read((0, react_1.useState)(false), 2), isButtonRendered = _c[0], setButtonRendered = _c[1];
    var containerRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (!paypalCheckout)
            loadPaypalSDK();
    }, [window.paypal, containerRef.current]);
    (0, react_1.useEffect)(function () {
        createPaypalButton();
    }, [!!paypalCheckout, containerRef.current]);
    var createPaypalButton = function () { return __awaiter(void 0, void 0, void 0, function () {
        var paypal;
        return __generator(this, function (_a) {
            paypal = window.paypal;
            if (!paypalCheckout || !paypal || !containerRef.current)
                return [2 /*return*/];
            if (isButtonRendered)
                return [2 /*return*/];
            paypal
                .Buttons({
                fundingSource: paypal.FUNDING.PAYPAL,
                createBillingAgreement: function () { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        return [2 /*return*/, paypalCheckout.createPayment({
                                flow: 'vault',
                                enableShippingAddress: true,
                            })];
                    });
                }); },
                onApprove: function (data) { return __awaiter(void 0, void 0, void 0, function () {
                    var payload;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, paypalCheckout.tokenizePayment(data)];
                            case 1:
                                payload = _a.sent();
                                window.location.href = "/pages/checkout/?pp=".concat(btoa(JSON.stringify(payload)));
                                return [2 /*return*/];
                        }
                    });
                }); },
                style: {
                    height: 48,
                },
            })
                .render(containerRef.current);
            setButtonRendered(true);
            return [2 /*return*/];
        });
    }); };
    var paymentAuth = window.cartSettings.paymentAuth;
    var loadPaypalSDK = function () { return __awaiter(void 0, void 0, void 0, function () {
        var btClient, ppCheckout;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!paymentAuth)
                        return [2 /*return*/];
                    return [4 /*yield*/, braintree_web_1.default.client.create({ authorization: paymentAuth })];
                case 1:
                    btClient = _a.sent();
                    return [4 /*yield*/, braintree_web_1.default.paypalCheckout.create({ client: btClient })
                        // load the paypal JS into the window
                    ];
                case 2:
                    ppCheckout = _a.sent();
                    // load the paypal JS into the window
                    return [4 /*yield*/, ppCheckout.loadPayPalSDK({ vault: true })]; // TODO: update @types/braintree-web
                case 3:
                    // load the paypal JS into the window
                    _a.sent(); // TODO: update @types/braintree-web
                    setPaypalCheckout(ppCheckout);
                    return [2 /*return*/];
            }
        });
    }); };
    if (!paypalCheckout)
        return null;
    return react_1.default.createElement("div", { id: paypalButtonContainerId, ref: containerRef });
});
